import { CheckmarkFilled, CloseFilled } from '@carbon/icons-react';
import styled from '@emotion/styled';

import {
  PasswordValidations,
  PasswordRequirements
} from 'components/PasswordField/types';
import {
  DEFAULT_PASSWORD_REQUIREMENTS,
  getDefaultPasswordValidations
} from 'components/PasswordField/utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l2);
  padding: var(--spacing-l2) 0;
`;

const RequirementRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-l2);

  svg {
    flex-shrink: 0;
  }
`;

export const Checkmark = styled(CheckmarkFilled)`
  color: var(--success);
`;

export const Close = styled(CloseFilled)<{ 'data-state': 'default' | 'dirty' }>`
  color: var(--text-placeholder);

  &[data-state='dirty'] {
    color: var(--error);
  }
`;

export function PasswordValidationsProgress({
  value,
  email,
  passwordValidations = getDefaultPasswordValidations(),
  passwordRequirements = DEFAULT_PASSWORD_REQUIREMENTS,
  isDirty
}: {
  value: string;
  email: string;
  passwordValidations?: PasswordValidations;
  passwordRequirements?: PasswordRequirements;
  isDirty: boolean;
}): JSX.Element {
  return (
    <Wrapper>
      {passwordValidations.map(({ name, getLabel, isValid }) => {
        const isValidationPassed = isValid({
          value,
          email,
          passwordRequirements
        });

        return (
          <RequirementRow key={name}>
            <>
              {isValidationPassed ? (
                <Checkmark size={16} />
              ) : (
                <Close size={16} data-state={isDirty ? 'dirty' : 'default'} />
              )}
            </>
            <span>
              {getLabel({ minLength: passwordRequirements.minLength })}
            </span>
          </RequirementRow>
        );
      })}
    </Wrapper>
  );
}
